import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkEmpty'
})
export class CheckEmptyPipe implements PipeTransform {

  transform(value: string): string {
    if (!value || value === "" || value === null || value === undefined) { return "--"; }
    if (value === 'NaN') {return '0'; }
    return value;
  }

}
